import type { Dispatch, SetStateAction } from 'react'

import type { GetUsersListFilters } from '@/modules/chatting/types'
import { UsersListFilters } from '@/modules/chatting/ui/components/UsersListFilters/UsersListFilters'

interface Props {
  filters: GetUsersListFilters
  setFilters: Dispatch<SetStateAction<GetUsersListFilters>>
}
export const FansFilters = ({ filters, setFilters }: Props) => {
  return (
    <UsersListFilters
      includeSignedUpFilters={false}
      filters={filters}
      setFilters={setFilters}
    />
  )
}
